export default __webpack_public_path__ + "static/media/boy.d1ac55e9.png";